/**
 * 前端通用格式化函数
 */

/**
 * 格式化文件大小
 * @param {number} bytes
 * @returns {string}
 */
export function formatFileSize(bytes) {
  if (!bytes) return '-';
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  if (bytes < 1024 * 1024 * 1024) return (bytes / 1024 / 1024).toFixed(1) + ' MB';
  return (bytes / 1024 / 1024 / 1024).toFixed(2) + ' GB';
}

/**
 * 产品颜色映射
 */
export const PRODUCT_COLORS = {
  T6290E: '#1677ff',
  T6290ES: '#722ed1',
  T6290F: '#13c2c2',
  T8290A: '#eb2f96',
  WelzekViewer: '#0891b2',
  Welzek_WaveBox: '#0f766e',
  T6290_SCPI_Manual: '#b45309',
};

export const PRODUCT_DISPLAY_NAMES = {
  T6290_SCPI_Manual: 'T6290 指令手册',
};

export function getProductDisplayName(model) {
  return PRODUCT_DISPLAY_NAMES[model] || model;
}

/**
 * 产品排序顺序
 */
export const PRODUCT_ORDER = ['T6290F', 'T6290E', 'T6290ES', 'T8290A', 'T6290_SCPI_Manual', 'Welzek_WaveBox', 'WelzekViewer'];

/**
 * 支持每日版本的产品
 */
export const DAILY_PRODUCTS = ['T6290E', 'T6290ES', 'T6290F', 'T8290A', 'WelzekViewer'];

/**
 * 只支持每日版本的产品
 */
export const DAILY_ONLY_PRODUCTS = [];

/**
 * 主版本页面隐藏的产品（不影响组件版本）
 */
export const HIDDEN_MAIN_VERSION_PRODUCTS = ['Welzek_UI'];

export function isMainVersionProductVisible(product) {
  return product?.model !== 'MARKET' && !HIDDEN_MAIN_VERSION_PRODUCTS.includes(product?.model);
}

/**
 * 支持 GitLab 的产品列表
 */
export const GITLAB_PRODUCTS = ['T6290E', 'T6290ES', 'T6290F', 'T8290A', 'WelzekViewer', 'Welzek_WaveBox', 'T6290_SCPI_Manual'];

/**
 * 状态显示映射
 */
export const STATUS_MAP = {
  draft: { text: '草稿', color: 'default' },
  pre_released: { text: '已预发布', color: 'purple' },
  released: { text: '已发布', color: 'success' },
  deprecated: { text: '已废弃', color: 'error' },
};

/**
 * 将 UTC 时间字符串转换为本地时间显示
 * SQLite 返回格式: 2026-04-28 08:10:35
 */
export function formatDateTime(utcStr) {
  if (!utcStr) return '-';
  const date = new Date(utcStr + 'Z');
  if (isNaN(date.getTime())) return utcStr;
  return date.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
}

/**
 * 发布类型映射
 */
export const RELEASE_TYPE_MAP = {
  major: { text: '大版本', color: 'red' },
  minor: { text: '小版本', color: 'blue' },
  patch: { text: '补丁', color: 'green' },
};
